import { FormState, Radio, RadioGroup } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { messages } from './messages'
import styles from './styles.css'

const MOST_EXPENSIVE_CONFIG = 'mostExpensive'

type Props = {
  state: FormState
}

export function MostExpensive(props: Props) {
  const { state } = props
  const { $t } = useIntl()

  return (
    <RadioGroup
      name={MOST_EXPENSIVE_CONFIG}
      label={
        <div className={styles.radioGroupLabel}>
          {$t(messages.mostExpensive.group)}
        </div>
      }
      state={state}
    >
      {[false, true].map((value) => (
        <Radio
          key={String(value)}
          label={$t(messages.mostExpensive.radio, { value })}
          value={String(value)}
        />
      ))}
    </RadioGroup>
  )
}
